const AntdTheme = {
  token: {
    borderRadius: 4,
    borderRadiusLG: 6,
    borderRadiusSM: 2,
  },
}

export default AntdTheme